<template>
    <div class="rules-container">
        <!-- 规则说明 -->
        <el-alert title="佣金规则说明" type="info" :closable="false" show-icon class="rules-alert">
            <template slot="default">
                <p>1. 全局规则为默认佣金计算方式，当线路未单独配置时使用此规则</p>
                <p>2. 线路单独配置的佣金规则优先级高于全局规则</p>
                <p>3. 佣金结算周期决定订单完成后多久佣金可提现</p>
            </template>
        </el-alert>

        <el-row :gutter="24">
            <!-- 全局规则配置 -->
            <el-col :span="14">
                <div class="rule-card">
                    <div class="rule-header">
                        <span class="rule-title"><i class="el-icon-s-tools"></i> 全局佣金规则</span>
                        <el-tag size="small" :type="ruleStatus === 1 ? 'success' : 'info'">
                            {{ ruleStatus === 1 ? '生效中' : '未生效' }}
                        </el-tag>
                    </div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="rule-form">
                        <el-form-item label="默认佣金类型" prop="commissionType">
                            <el-checkbox-group v-model="commissionTypeValue" @change="handleTypeChange">
                                <el-checkbox v-for="item in commissionTypeOptions" :key="item.value"
                                    :label="item.value">
                                    {{ item.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="默认佣金值" prop="commissionValue">
                            <div class="commission-input">
                                <el-input-number v-model="ruleForm.commissionValue" :min="0"
                                    :max="ruleForm.commissionType === 1 ? 9999 : 100" :precision="2"
                                    :step="ruleForm.commissionType === 1 ? 1 : 0.1" class="commission-number">
                                </el-input-number>
                                <span class="commission-unit">{{ ruleForm.commissionType === 1 ? '元/单' : '%' }}</span>
                            </div>
                            <div class="form-tip">
                                {{ ruleForm.commissionType === 1 ? '每单固定佣金金额' : '按订单金额百分比计算' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="佣金承担方" prop="commissionBearer">
                            <el-radio-group v-model="ruleForm.commissionBearer">
                                <el-radio :label="1">平台承担</el-radio>
                                <el-radio :label="2">司机承担</el-radio>
                            </el-radio-group>
                            <div class="form-tip">
                                {{ ruleForm.commissionBearer === 2 ? '佣金从司机收入中扣除，司机实际到账 = 订单金额 - 佣金' : '佣金由平台承担，不影响司机收入' }}
                            </div>
                        </el-form-item>
                    <el-form-item label="佣金结算周期" prop="settlementCycle">
                            <el-select v-model="ruleForm.settlementCycle" placeholder="请选择" style="width: 200px;">
                                <el-option
                                    v-for="item in settlementPeriodOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    <span>{{ item.label }}</span>
                                    <span style="color: #909399; font-size: 12px; margin-left: 10px;">{{ item.desc }}</span>
                                </el-option>
                            </el-select>
                    </el-form-item>
<!--                        <el-form-item label="最低提现金额" prop="minWithdrawal">-->
<!--                            <el-input-number v-model="ruleForm.minWithdrawal" :min="1" :max="1000" :precision="0"-->
<!--                                style="width: 200px;">-->
<!--                            </el-input-number>-->
<!--                            <span class="commission-unit">元</span>-->
<!--                        </el-form-item>-->
                        <el-form-item label="规则说明">
                            <el-input type="textarea" v-model="ruleForm.remark" :rows="3" placeholder="请输入规则说明（可选）"
                                maxlength="200" show-word-limit>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-check" @click="handleSave"
                                :loading="saveLoading">保存配置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>

            <!-- 规则预览 -->
            <el-col :span="10">
                <div class="rule-card preview-card">
                    <div class="rule-header">
                        <span class="rule-title"><i class="el-icon-view"></i> 规则预览</span>
                    </div>
                    <div class="preview-content">
                        <div class="preview-item">
                            <span class="preview-label">佣金类型</span>
                            <span class="preview-value">{{ ruleForm.commissionType === 1 ? '固定金额' : '百分比' }}</span>
                        </div>
                        <div class="preview-item">
                            <span class="preview-label">佣金值</span>
                            <span class="preview-value highlight">
                                {{ ruleForm.commissionValue }}{{ ruleForm.commissionType === 1 ? '元/单' : '%' }}
                            </span>
                        </div>
                        <div class="preview-item">
                            <span class="preview-label">结算周期</span>
                            <span class="preview-value">{{ getSettlementLabel(ruleForm.settlementCycle) }}</span>
                        </div>
                        <div class="preview-item">
                            <span class="preview-label">佣金承担方</span>
                            <span class="preview-value" :style="{ color: ruleForm.commissionBearer === 2 ? '#E6A23C' : '#67C23A' }">
                                {{ ruleForm.commissionBearer === 2 ? '司机承担' : '平台承担' }}
                            </span>
                        </div>
                        <div class="preview-item">
                            <span class="preview-label">最低提现</span>
                            <span class="preview-value" style="color: #409EFF;">{{ ruleForm.minWithdrawal || 10 }}元</span>
                        </div>
                        <el-divider></el-divider>
                        <div class="preview-example">
                            <div class="example-title">佣金计算示例</div>
                            <div class="example-content">
                                <p>假设订单金额为 <strong style="color: #409EFF;" class="text-primary">¥100.00</strong></p>
                                <p>渠道可获得佣金：<strong style="color: #409EFF;" class="text-primary">¥{{ calculateExampleCommission() }}</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'CommissionRule',
    data() {
        return {
            ruleForm: {
                id: null, // 配置ID（更新时使用）
                commissionType: 2,
                commissionValue: 5,
                settlementCycle: 1, // 1-实时结算，2-按天结算，3-按周结算，4-按月结算
                commissionBearer: 1, // 1-平台承担，2-司机承担
                minWithdrawal: 10,
                remark: ''
            },
            ruleStatus: 1, // 1-生效中，2-未生效
            rules: {
                commissionType: [
                    { required: true, message: '请选择佣金类型', trigger: 'change' }
                ],
                commissionValue: [
                    { required: true, message: '请输入佣金值', trigger: 'blur' }
                ],
                commissionBearer: [
                    { required: true, message: '请选择佣金承担方', trigger: 'change' }
                ],
                settlementCycle: [
                    { required: true, message: '请选择结算周期', trigger: 'change' }
                ],
                minWithdrawal: [
                    { required: true, message: '请输入最低提现金额', trigger: 'blur' }
                ]
            },
            saveLoading: false
        }
    },
  computed: {
    commissionTypeOptions() {
      return this.$const.CHANNEL_COMMISSION_TYPE || []
    },
    settlementPeriodOptions() {
      return this.$const.CHANNEL_COMMISSION_SETTLEMENT_PERIOD || []
    },
    commissionTypeValue: {
      get() {
        return this.ruleForm.commissionType ? [this.ruleForm.commissionType] : []
      },
      set(val) {
        // 确保只能选择一个
        if (val.length > 1) {
          // 保留最新选择的值
          this.ruleForm.commissionType = val[val.length - 1]
        } else if (val.length === 1) {
          this.ruleForm.commissionType = val[0]
        } else {
          this.ruleForm.commissionType = null
        }
      }
    }
  },
    created() {
        this.getCommissionRule()
    },
    methods: {
        /**
         * 获取佣金规则配置
         * 作者：孙艺
         */
        async getCommissionRule() {
            try {
                const res = await this.$axios.get('/api/v1/channel/commissionConfig')
                if (res && res.code === 1 && res.data) {
                    const { id, commissionType, commissionValue, settlementPeriod, commissionBearer, minWithdrawalAmount, ruleDescription, status } = res.data
                    this.ruleForm = {
                        id: id || null,
                        commissionType: commissionType || 2,
                        commissionValue: commissionValue || 5,
                        settlementCycle: settlementPeriod || 1, // settlementPeriod: 1-实时结算，2-按天结算，3-按周结算，4-按月结算
                        commissionBearer: commissionBearer || 1, // 1-平台承担，2-司机承担
                        minWithdrawal: minWithdrawalAmount || 10,
                        remark: ruleDescription || ''
                    }
                    this.ruleStatus = status || 1
                }
            } catch (error) {
                console.error('获取佣金规则配置失败:', error)
                this.$message.error('获取佣金规则配置失败')
            }
        },
        /**
         * 保存配置
         * 作者：孙艺
         */
        async handleSave() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.saveLoading = true
                    try {
                        const { id, commissionType, commissionValue, settlementCycle, commissionBearer, minWithdrawal, remark } = this.ruleForm
                        const res = await this.$axios.post('/api/v1/channel/commissionConfig/save', {
                            ...(id && { id }),
                            commissionType,
                            commissionValue,
                            settlementPeriod: settlementCycle,
                            commissionBearer: commissionBearer || 1,
                            minWithdrawalAmount: minWithdrawal,
                            ruleDescription: remark || '',
                            ...(this.mixinUserInfo?.organizationId && { organizationId: this.mixinUserInfo.organizationId })
                        })
                        if (res && res.code === 1) {
                            this.$message.success('保存成功')
                            await this.getCommissionRule()
                        } else {
                            this.$message.error(res.msg || '保存失败')
                        }
                    } catch (error) {
                        console.error('保存佣金规则配置失败:', error)
                        this.$message.error('保存失败')
                    } finally {
                        this.saveLoading = false
                    }
                }
            })
        },
        /**
         * 重置表单
         * 作者：孙艺
         */
        handleReset() {
            this.getCommissionRule()
        },
        /**
         * 佣金类型切换
         * 作者：孙艺
         */
        handleTypeChange() {
            // 切换类型时重置佣金值
            this.ruleForm.commissionValue = this.ruleForm.commissionType === 1 ? 5 : 5
        },
    /**
     * 获取结算周期标签
     * 作者：孙艺
     * @param {Number} value - 结算周期值：1-实时结算，2-按天结算，3-按周结算，4-按月结算
     * @returns {String} 结算周期标签
     */
    getSettlementLabel(value) {
      const option = this.settlementPeriodOptions.find(item => item.value === value)
      return option ? option.label : '未知'
    },
        /**
         * 计算示例佣金
         * 作者：孙艺
         * @returns {String} 示例佣金金额
         */
        calculateExampleCommission() {
            if (this.ruleForm.commissionType === 1) {
                return this.ruleForm.commissionValue.toFixed(2)
            } else {
                return (100 * this.ruleForm.commissionValue / 100).toFixed(2)
            }
        },
        /**
         * 刷新数据（供父组件调用）
         * 作者：孙艺
         */
        refresh() {
            this.getCommissionRule()
        }
    }
}
</script>

<style lang="less" scoped>
.rules-container {
    padding: 4px 0;
    .rules-alert {
        margin-bottom: 16px;

        p {
            margin: 4px 0;
            font-size: 12px;
        }
    }
}

// 规则卡片
.rule-card {
    background: #fff;
    border-radius: 6px;
    padding: 20px;
    height: 100%;

    .rule-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 12px;
        border-bottom: 1px solid #EBEEF5;

        .rule-title {
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                margin-right: 6px;
                color: #409EFF;
            }
        }
    }

    .rule-form {
        .commission-input {
            display: flex;
            align-items: center;
        }

        .commission-unit {
            margin-left: 10px;
            color: #606266;
        }

        .form-tip {
            font-size: 12px;
            color: #909399;
            margin-top: 4px;
        }
    }
}

// 预览卡片
.preview-card {
    .preview-content {
        .preview-item {
            display: flex;
            justify-content: space-between;
            padding: 12px 0;
            border-bottom: 1px solid #f5f5f5;

            .preview-label {
                color: #909399;
                font-size: 13px;
            }

            .preview-value {
                color: #303133;
                font-size: 13px;
                font-weight: 500;

                &.highlight {
                    color: #409EFF;
                    font-size: 16px;
                }
            }
        }

        .preview-example {
            margin-top: 16px;
            padding: 16px;
            background: #f5f7fa;
            border-radius: 6px;

            .example-title {
                font-size: 13px;
                font-weight: 600;
                color: #303133;
                margin-bottom: 8px;
            }

            .example-content {
                font-size: 13px;
                color: #606266;

                p {
                    margin: 4px 0;
                }


            }
        }
    }
}
</style>
